import {
  CatalogData,
  CertificateValidity,
  DocData,
  IFSRequest,
  PRComment,
  updatedCatalog,
} from '@app/models/import_free_sales/ImpFreeSalesRequest';
import {
  IFSTableData,
  IFSTableRow,
  IFSResponse,
  IFSApiData,
  Parameters,
  UploadDocumentResponse,
  SiteVisitDocResponse,
} from '@app/models/import_free_sales/ImpFreeSalesResponse';
import { post, get, remove } from './http.api';
const cat_id = Number(localStorage.getItem('selected_category_id')) || 0;

export const getImpFreeSalesData = async (parameters: Parameters): Promise<IFSTableData> => {
  try {
    const { data, status } = await get<any>(
      'product_registrations',
      {
        params: parameters,
      },
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    const impfreesales: IFSTableRow[] = data.product_registrations.data.map((ifsData: any) => ({
      id: ifsData.id,
      code: ifsData.code,
      pr_type: ifsData.pr_type,
      pr_product_id: ifsData.pr_product_id,
      expires_at: ifsData.expires_at,
      status: ifsData.status,
      pr_location_code: ifsData.pr_location_code,
      pr_location_name: ifsData.pr_location_name,
    }));

    return {
      data: impfreesales,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
      status_options: data.status_options,
      pr_product_options: data.pr_product_options,
      pr_types_options: data.pr_types_options,
      is_location: data.is_location ?? false,
    };
  } catch (error: any) {
    console.error('Error fetching Product Registrations:', error);
    throw error;
  }
};

export const getAllImpFreeSales = async (): Promise<IFSResponse> => {
  try {
    const { data, status } = await get<IFSResponse>(`product_registrations`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getIFSById = async (id: number): Promise<IFSResponse> => {
  try {
    const { data, status } = await get<IFSResponse>(`product_registrations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeIFS = async (ifsData: IFSRequest) => {
  try {
    const response = await post<any>('product_registrations/create', ifsData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createIFS = async (categoryId?: number): Promise<IFSApiData> => {
  try {
    const url = categoryId
      ? `product_registrations/create?pr_category_id=${categoryId}`
      : `product_registrations/create`;
    const { data, status } = await get<IFSApiData>(url, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showIFS = async (id: number) => {
  try {
    const { data, status } = await get<IFSApiData>(`product_registrations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editIFS = async (id: number) => {
  try {
    const { data, status } = await get<IFSApiData>(`product_registrations/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateIFS = async (id: number, UpdateIFS: IFSRequest) => {
  try {
    const { data, status } = await post<IFSRequest>(`product_registrations/${id}/edit`, UpdateIFS, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateStatus = async (id: number, action: any) => {
  try {
    const { data, status } = await post<IFSRequest>(`product_registrations/${id}/do_action`, action, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error('API Error:', error);

    if (error?.status) {
      throw error;
    }
    throw {
      status: error?.response?.status || 500,
      message: error?.response?.data?.message || error?.message || 'An unexpected error occurred',
      errors: error?.response?.data?.errors,
    };
  }
};

export const storeComment = async (id: number, commentData: PRComment) => {
  try {
    const response = await post<any>(`product_registrations/${id}/store_comment`, commentData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateComment = async (id: number, com_id: number, commentData: PRComment) => {
  try {
    const { data, status } = await post<PRComment>(
      `product_registrations/${id}/${com_id}/update_comment`,
      commentData,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const uploadDocument = async (id: number, formData: FormData): Promise<UploadDocumentResponse> => {
  try {
    const { data, status } = await post<UploadDocumentResponse>(
      `product_registrations/${id}/upload_document`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    );
    console.log('Status:', status, 'Data:', data);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const renewRegistration = async (id: number) => {
  try {
    const response = await post<any>(`product_registrations/${id}/renew`, undefined, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const appealRegistration = async (id: number) => {
  try {
    const response = await post<any>(`product_registrations/${id}/appeal`, undefined, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const amendProducts = async (id: number, catalogData: CatalogData) => {
  try {
    const response = await post<CatalogData>(`product_registrations/${id}/amend`, catalogData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const generateInvoice = async (id: number, invoiceType: string) => {
  try {
    const response = await post<any>(
      `product_registrations/${id}/create_invoice`,
      { invoice_type: invoiceType },
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getInvoice = async (id: number) => {
  try {
    const { data, status } = await get<any>(`/invoices/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const generateCertificate = async (id: number) => {
  try {
    const response = await post<any>(`product_registrations/${id}/generate_certificate`, undefined, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getCertificate = async (id: number) => {
  try {
    const { data, status } = await get<any>(`product_registrations/${id}/certificates`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const uploadFinalCertificate = async (id: number, file: FormData): Promise<any> => {
  try {
    const { data, status } = await post<any>(`product_registrations/${id}/upload_certificate`, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('Status:', status, 'Data:', data);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getCertificateExpiration = async (id: number) => {
  try {
    const { data, status } = await get<any>(`product_registrations/${id}/get_expires_at`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const setCertificateValidity = async (id: number, validityData: CertificateValidity) => {
  try {
    const response = await post<any>(`product_registrations/${id}/set_validity`, validityData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateCatalog = async (id: number, updatedCatalogData: updatedCatalog) => {
  try {
    const response = await post<CatalogData>(
      `product_registrations/${id}/set_catalog_product_codes`,
      updatedCatalogData,
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const uploadSiteVisitDocs = async (id: number, formData: FormData): Promise<SiteVisitDocResponse> => {
  try {
    const { data, status } = await post<SiteVisitDocResponse>(
      `product_registrations/${id}/upload_visit_document`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    );
    console.log('Status:', status, 'Data:', data);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const DeleteVisitDoc = async (id: number, doc_id: number) => {
  try {
    const response = await remove<any>(`/product_registrations/${id}/pr_visit_documents/${doc_id}`, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updatecData = async (id: number, UpdatecData: any) => {
  try {
    const { data, status } = await post<any>(`product_registrations/${id}/update`, UpdatecData, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getPRCategories = async (): Promise<any> => {
  try {
    const { data, status } = await get<any>(`product_registrations/get_pr_categories`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};
